export default __webpack_public_path__ + "static/error-74e8d5d8bc43e8d24968581882797a1c.webp";